export default __webpack_public_path__ + "static/media/close-icon.6a8319be.svg";